import { DeclareExtract } from '../../declare-extract.decorator';
import { Extract, ExtractType } from '../../extract';

@DeclareExtract('count_comparison')
export class CountComparison extends Extract {
  name = 'count_comparison';
  type = ExtractType.COMPARISON;
  chartType = 'bar';
}
